<template>
	<div>
		
	</div>
</template>

<script>
import { auth } from "@libs/wechat";
import { getHomeData } from "@api/public";
import { mapGetters } from "vuex";
export default {
  name: "IndexBlank",
  computed: mapGetters(["isLogin"]),
  mounted: function() {
	this.getAuth();
  },
  methods: {
	  getAuth(){
		  const { code, state } = this.$route.query;
		  console.log('codecodecodecodecode'+code);
		  console.log('statestatestatestate'+state);
		  console.log('route.query++' + this.$route.query.url);
		  if(code && state){
			  console.log('进来啦auth');
			auth(code, state).then(() => {
				console.log('成功url++' + this.$route.query.url);
				  if(this.$route.query.url){
					  console.log('可以跳转啦');
					  // this.$dialog.success('url++'+this.$route.query.url)
					  console.log('跳转route.query++' + this.$route.query.url);
					  console.log('跳转hrefhrefhrefhrefhref' + decodeURIComponent(this.$route.query.url));
					  location.href = decodeURIComponent(decodeURIComponent(this.$route.query.url));
				  }
			  })
			  .catch(() => {
			    // location.replace("/");
				// this.$dialog.error('没有url');
			  });  
		  }else{
			  this.getIndex();
		  }
	  },
	  getIndex(){
		  var that = this;
		  getHomeData(0).then(res => {
			  if(res.data.homepage_activity_info.display){
				that.$router.replace('/index_activity_new/' + res.data.homepage_activity_info.id);
			  	return false;
			  }
		  }).catch(err => {
			  that.$dialog.error(err);
		  });
	  }
  }
}
</script>

